import { render, staticRenderFns } from "./quick-change-form.vue?vue&type=template&id=60868d14&"
import script from "./quick-change-form.vue?vue&type=script&lang=ts&"
export * from "./quick-change-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports